var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("sidebar-widget", {
    attrs: {
      id: "courseware-action-widget",
      title: _vm.$gettext("Aktionen"),
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function fn() {
          return [
            _c(
              "ul",
              {
                staticClass: "widget-list widget-links cw-action-widget",
              },
              [
                _vm.taskGroup
                  ? [
                      _vm.isBeforeEndDate
                        ? _c(
                            "li",
                            {
                              staticClass:
                                "cw-action-widget-task-groups-deadline",
                            },
                            [
                              _c(
                                "button",
                                {
                                  on: {
                                    click: function click($event) {
                                      return _vm.modifyDeadline(_vm.taskGroup)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$gettext(
                                          "Bearbeitungszeit verlängern"
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isBeforeEndDate
                        ? _c(
                            "li",
                            {
                              staticClass:
                                "cw-action-widget-task-groups-add-solvers",
                            },
                            [
                              _c(
                                "button",
                                {
                                  on: {
                                    click: function click($event) {
                                      return _vm.addSolvers(_vm.taskGroup)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$gettext("Teilnehmende hinzufügen")
                                      ) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          staticClass: "cw-action-widget-task-groups-delete",
                        },
                        [
                          _c(
                            "button",
                            {
                              on: {
                                click: function click($event) {
                                  return _vm.deleteTaskGroup(_vm.taskGroup)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$gettext("Aufgabe löschen")) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  : _c(
                      "li",
                      {
                        staticClass: "cw-action-widget-add",
                      },
                      [
                        _c(
                          "button",
                          {
                            on: {
                              click: function click($event) {
                                return _vm.setShowTasksDistributeDialog(true)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.$gettext("Aufgabe verteilen")) +
                                "\n                "
                            ),
                          ]
                        ),
                      ]
                    ),
              ],
              2
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }